import { CacheUser } from '../../core/models/cache';
import { DBUser } from './types';

export function mapCacheUserToDBUser(user: CacheUser): DBUser {
  return {
    id: user.id,
    username: user.username
  };
}
